import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { Box, Button, Tooltip, Typography } from '@mui/material'
import Loading from 'components/loading'
import { useStyles } from './styles'

interface DinamicTableProps {
  data: any[]
  rowsPerPage: number
  page: number
  totalPages: number
  isLoading?: boolean
  onChangeRowPerPage: (rowsPerPage: number) => void
  handlePrevPage: () => void
  handleNextPage: () => void
}

const DinamicTable = ({
  data,
  rowsPerPage,
  page,
  isLoading,
  totalPages,
  handleNextPage,
  handlePrevPage,
  onChangeRowPerPage,
}: DinamicTableProps) => {
  const classes = useStyles()
  const rowsPerPageOptions = [10, 25, 50, 100]

  if (isLoading) {
    return <Loading />
  }

  if (data.length === 0) {
    return (
      <Box className={classes.center}>
        <p>Nenhum dado disponível</p>
      </Box>
    )
  }

  const keys = Object.keys(data[0])

  return (
    <>
      <Box className={classes.container}>
        <table className={classes.table}>
          <thead className={classes.thead}>
            <tr className={classes.head}>
              {keys.map((key) => (
                <Tooltip
                  key={key}
                  title={key.replace(/_/g, ' ')}
                  arrow
                >
                  <th className={classes.th}>
                    <span className={classes.ellipsis}>{key.replace(/_/g, ' ')}</span>
                  </th>
                </Tooltip>
              ))}
            </tr>
          </thead>
          <tbody className={classes.tbody}>
            {data.map((item, index: number) => (
              <tr
                key={index}
                className={classes.body}
              >
                {keys.map((key) => (
                  <Tooltip
                    key={key}
                    title={item[key]}
                    arrow
                  >
                    <td className={classes.td}>
                      <span className={classes.ellipsis}>{item[key]}</span>
                    </td>
                  </Tooltip>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <Box className={classes.paginationContainer}>
        <Box className={classes.rowsPerPage}>
          <Typography variant='body1'>Linhas por página:</Typography>
          <select
            className={classes.select}
            value={rowsPerPage}
            onChange={(e) => onChangeRowPerPage(Number(e.target.value))}
          >
            {rowsPerPageOptions.map((option) => (
              <option
                key={option}
                value={option}
              >
                {option}
              </option>
            ))}
          </select>
        </Box>

        <Typography
          variant='body1'
          className={classes.pageInfo}
        >
          <span>
            {(page - 1) * rowsPerPage + 1}-{page * rowsPerPage} de {totalPages}
          </span>
        </Typography>

        <Box className={classes.navigationButtons}>
          <Button
            size='small'
            className={classes.button}
            onClick={handlePrevPage}
            disabled={page === 1}
          >
            <KeyboardArrowLeft />
          </Button>

          <Button
            size='small'
            className={classes.button}
            onClick={handleNextPage}
            disabled={page === totalPages}
          >
            <KeyboardArrowRight />
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default DinamicTable
